const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const FREELANCERS = {
    SIGNUP: `${API_BASE_URL}/freelancers/freelance-signup/`,
    CHECK_PROFILE: `${API_BASE_URL}/freelancers/check-freelancer/`,
    PROFILE_VIEW: (id) => `${API_BASE_URL}/freelancers/freelancer-profile-view/${id}/`, 
    ALL: `${API_BASE_URL}/freelancers/freelancers/`,
    BY_ID: `${API_BASE_URL}/freelancers/freelancer-id/`,
    UPDATE_PROFILE: `${API_BASE_URL}/freelancers/freelancer-update-profile/`,
    IMAGE_UPLOAD: `${API_BASE_URL}/freelancers/freelancer-image-upload/`,
    IMAGES_UPLOAD: `${API_BASE_URL}/freelancers/freelancer-job-images-upload/`,
    COVER_UPLOAD: `${API_BASE_URL}/freelancers/freelancer-cover-upload/`,
    JOB_IMAGES: `${API_BASE_URL}/freelancers/job-images/`,
    DELETE_IMAGE: (imageId) => `${API_BASE_URL}/freelancers/delete-image/${imageId}/`,
};

export default FREELANCERS;